import React, { useState } from 'react'
import { Box, Button, Grid, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { GetApp as ImportIcon } from '@material-ui/icons'

import usePhishing from 'hooks/usePhishing'

import useStyles from './styles'
import { ImportParticipantsDialog } from './components'

const ExternalSection = ({
  departments,
  isDepartmentsLoading,
  onAdd,
  disabled,
  externalRecipients = [],
}) => {
  const classes = useStyles()
  const { phishing } = usePhishing()

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState('')
  const [department, setDepartment] = useState(null)
  const [importOpen, setImportOpen] = useState(false)

  const handleEmailChange = (value) => {
    setEmail(value)
    if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setEmailError('E-mail inválido')
    } else if (
      value &&
      externalRecipients.some(
        (recipient) => recipient.email.toLowerCase() === value.toLowerCase(),
      )
    ) {
      setEmailError('E-mail já adicionado')
    } else {
      setEmailError('')
    }
  }

  const handleConfirm = () => {
    if (!name || !email || !department || emailError) return
    onAdd({ name, email, department })
    setName('')
    setEmail('')
    setEmailError('')
    setDepartment(null)
  }

  const handleImport = (participant) => {
    const alreadyAdded = externalRecipients.some(
      (recipient) =>
        recipient.email.toLowerCase() === participant.email.toLowerCase(),
    )
    if (!alreadyAdded) onAdd(participant)
  }

  return (
    <Box className={classes.sectionBox}>
      <Box className={classes.sectionHeader}>
        <Box>
          <Typography variant="subtitle1" className={classes.sectionTitle}>
            Adicionar colaborador externo
          </Typography>
          <Typography className={classes.sectionSubtitle}>
            Cadastre colaboradores que não possuem acesso à plataforma. Eles
            participarão da campanha, mas não terão acesso ao sistema.
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="primary"
          startIcon={<ImportIcon />}
          className={classes.importButton}
          disabled={disabled}
          onClick={() => setImportOpen(true)}
        >
          Importar participantes
        </Button>
      </Box>

      <Box className={classes.externalBox}>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Nome"
              placeholder="Nome"
              variant="outlined"
              size="small"
              value={name}
              disabled={disabled}
              onChange={(event) => setName(event.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="E-mail"
              placeholder="E-mail"
              variant="outlined"
              size="small"
              value={email}
              disabled={disabled}
              onChange={(event) => handleEmailChange(event.target.value)}
              error={!!emailError}
              helperText={emailError || ' '}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              options={departments}
              value={department}
              disabled={disabled}
              onChange={(_event, value) => setDepartment(value)}
              getOptionLabel={(option) => option.name}
              getOptionSelected={(option, value) => option.id === value.id}
              loading={isDepartmentsLoading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Departamento"
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.confirmButton}
              onClick={handleConfirm}
              disabled={
                disabled || !name || !email || !department || !!emailError
              }
            >
              Confirmar
            </Button>
          </Grid>
        </Grid>
      </Box>

      <ImportParticipantsDialog
        open={importOpen}
        setOpen={setImportOpen}
        phishingCampaignId={phishing?.id}
        departments={departments}
        isDepartmentsLoading={isDepartmentsLoading}
        onImport={handleImport}
      />
    </Box>
  )
}

export default ExternalSection
